import React from "react";
import ReactDOM from "react-dom";
import App from "./App";

//custom
import { BrowserRouter } from "react-router-dom";
import "materialize-css/dist/css/materialize.min.css";
import "materialize-css/dist/js/materialize.min.js";
import "react-datepicker/dist/react-datepicker.css";

//assests
import "./assests/css/AppDesign.css";

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById("root")
);
